<template>
  <div class="field-filter">
    <i-popup
      title="列表自定义"
      direction="north"
      :autoClose="false"
      icon-class="alexeistukov-icon icon-stop-square">
      <ul class="list">
        <i-checkbox-group v-model="checked" @change="handleChange">
          <li class="list-item" v-for="field in fields" :key="field.title">
            <i-checkbox v-if="field.title" :label="field.title + ''"></i-checkbox>
          </li>
        </i-checkbox-group>
      </ul>
    </i-popup>
  </div>
</template>
<script>
import grid from '@/mixins/grid'
import IPopup from '@/components/alexeistukov-popup'
export default {
  name: 'FieldFilter',
  components: {
    IPopup,
  },
  mixins: [grid],
  props: {
    fields: Array,
  },
  data() {
    return {
      checked: [],
    }
  },
  watch: {
    fields() {
      this.checked = []
      this.changeChecked()
    },
  },
  created() {
    this.changeChecked()
  },
  methods: {
    handleChange(checkedLabels) {
      this.fields.forEach(item => {
        if (~checkedLabels.indexOf(item.title)) {
          item.checked = true
        } else {
          item.checked = false
        }
      })
      this.$emit('changeColumns', this.fields) // 更新列表
      this.handleChangeFieldFilter() // 自定义列表存储
    },
    changeChecked() {
      // eslint-disable-next-line no-unused-vars
      for (const field of Object.values(this.fields)) {
        if ('checked' in field && !field.checked) {
          continue
        }
        this.checked.push(field.title)
      }
    },
  },
}
</script>
<style lang="scss">
.field-filter {
  display: inline-block;
  .list {
    padding: 6px 10px;
    max-height: 300px;
    overflow: auto;
    .list-item {
      margin-bottom: 6px;
      text-align: left;
      .el-checkbox {
        width: 100%;
        .el-checkbox-inner {
          border-radius: 4px;
        }
      }
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}
</style>